import { render, staticRenderFns } from "./UserDefence.vue?vue&type=template&id=24cd0ba8&"
import script from "./UserDefence.vue?vue&type=script&lang=js&"
export * from "./UserDefence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports